import { render, staticRenderFns } from "./gate-in-form.vue?vue&type=template&id=895ae204&"
import script from "./gate-in-form.vue?vue&type=script&lang=js&"
export * from "./gate-in-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports